import Immutable from 'immutable';
import repName from '../../../assets/images/rep_name.png';
import followBook from '../../../assets/images/follow_a_book.png';
import mailReminder from '../../../assets/images/mail_reminder.png';
import tradeRequestVideo from '../../../assets/videos/trade_request_example.mp4';
import React from 'react';

export const FEATURES = [
  {
    customIconStyle: 'fa fa-calendar',
    header: 'Scheduling Transparency \n - See office view',
    list: Immutable.List([
      'Coordinated Scheduling with partners'
    ]),
    media: () => <img className={ 'premium-features__image premium-features__image--right-rotate' } src={ repName } />
  },
  {
    customIconStyle: 'fa fa-envelope-o',
    header: 'Request Trades electronically',
    list: Immutable.List([
      'Send trade request to another rep'
    ]),
    media: () => <video className={ 'premium-features__video' }
      controls={ ['PlayPause', 'Seek', 'Time', 'Volume', 'Fullscreen'] }
      muted>
      <source src={ tradeRequestVideo } type='video/mp4' />
    </video>
  },
  {
    customIconStyle: 'fa fa-list-ol',
    header: 'Follow a book',
    list: Immutable.List([
      'Be first! Stay updated',
      'Receive scheduling INVITATION the day a book opens',
      'Be the first to know about cancellations when a book is full'
    ]),
    media: () => <img className={ 'premium-features__image premium-features__image--right-rotate' } src={ followBook } />
  },
  {
    customIconStyle: 'fa fa-clock-o',
    customTitleStyle: 'premium-features__title--indicator',
    header: 'Book 3x more appointments with scheduling notifications',
    list: Immutable.List([
      'Receive ADVANCE notification when a book is scheduled to open'
    ]),
    media: () => <img className={ 'premium-features__image premium-features__image--left-rotate' } src={ mailReminder } />
  }
];

export const FORM_NAME = 'paymentForm';



// WEBPACK FOOTER //
// ./app/components/reps/premium/constants.js